import moment from 'moment';
import _ from 'lodash';
import { STATUS as statusList, LOCALSTATUS as localStatusList } from '../../config';

const { to_send } = localStatusList;
const { in_progress } = statusList;

export class FillForm {
  constructor({ formManager, answerManager }) {
    this.formManager = formManager;
    this.answerManager = answerManager;
  }

  async saveValue(formId, path, value, questionId, questionType, questionChild = null, questionChiledType = null) {
    await this.registerValue(formId, path, value, questionId, questionType, questionChild, questionChiledType);
    const pathValue = path.split('.');
    if (pathValue.pop() === 'value') {
      await this.registerValue(formId, `${pathValue.join('.')}.timestamp`, moment().format('YYYY-MM-DD HH:mm:ss'));
    }
    await this.formManager.saveValue(formId, 'localStatus', to_send);
    await this.formManager.saveValue(formId, 'status', in_progress);
  }

  async registerValue(formId, path, value, questionId, questionType, questionChild = null, questionChiledType = null) {
    await this.answerManager.saveAnswerToRepo({
      value,
      formId,
      path,
      questionId: questionChild || questionId,
      questionType: questionChiledType || questionType,
    });
    await this.formManager.saveValue(formId, path, value, questionId, questionType, questionChild, questionChiledType);
  }

  async getValue(formId, path) {
    const form = await this.formManager.getFormFromLocal(formId);
    return _.get(form, path, null);
  }

  async saveImage(formId, dataUrl, path, questionId, questionType) {
    const imageId = await this.formManager.saveImage(formId, dataUrl, path, questionId, questionType);
    await this.formManager.saveValue(formId, path, imageId, questionId, questionType);
    return imageId;
  }

  async deleteImage(imageId) {
    await this.formManager.deleteImage(imageId);
  }
}
